
















































import { ApplicationUserModel, ShiftTypeModel } from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import { Guid } from '@/libs/common/functions/guid';
import {shiftTypesStore} from '@/libs/shift-types/+state/store';

@Component({})
export default class ShiftTypeDialog extends Page {

    id!: string;
    dialog = false;
    valid = true;
    saving = false;
    loading = false;
    applicationUser: ApplicationUserModel = applicationUserStore.useGetter(CrudGetter.Detail) as ApplicationUserModel;
    shiftType : ShiftTypeModel | null = null;
    deleteDialog = false;
    deleting = false;

    @Ref() form!: any;

    get isNewItem(): boolean {
        return this.shiftType?.id == Guid.EmptyGuid();
    }
    
    open (id: string) {
        this.dialog = true;
        this.id = id;
        this.load();
    }

    close () {
        this.dialog = false;
    }

    private load (): Promise<any> {
        if (this.id != Guid.EmptyGuid()) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                this.loadShiftType().then((e) => {
                    this.loading = false;
                    resolve(e);
                }).catch((e: any) => {
                    reject(e);
                });
            });
        }
        else {
            this.shiftType = {
                id: Guid.EmptyGuid(),
                name: ""
            } as ShiftTypeModel;
            return new Promise((resolve, reject) => {
                resolve(null);
            });
        }
    }

    private loadShiftType() {
        return new Promise((resolve, reject) => {
            shiftTypesStore.dispatch(CrudAction.Get, { id: this.id });
            this.subscribe(shiftTypesStore, CrudReponse.Get).then((e) => {
                this.shiftType = e;
                resolve(e);
            }).catch((e: any) => {
                reject(e);
            });
        });
    }

    private save () {
        if (this.form.validate()) {
            const shiftType = {...this.shiftType};
            this.saving = true;
            if (this.id == Guid.EmptyGuid()) {
                shiftTypesStore.dispatch(CrudAction.Create, { item: shiftType });
                this.subscribe(shiftTypesStore, CrudReponse.Create).then(() => {
                    this.load().then(() => {
                        this.saving = false;
                        this.close();
                    });
                }).catch((e) => {
                    this.saving = false;
                    throw e;
                });
            }
            else {
                shiftTypesStore.dispatch(CrudAction.Update, { item: shiftType });
                this.subscribe(shiftTypesStore, CrudReponse.Update).then(() => {
                    this.load().then(() => {
                        this.saving = false;
                        this.close();
                    });
                }).catch((e) => {
                    this.saving = false;
                    throw e;
                });
            }
        }
    }

    deleteClick () {
        this.deleteDialog = true;
    }

    deleteShiftType () {
        this.deleting = true;
        shiftTypesStore.dispatch(CrudAction.Delete, { id: this.id });
        this.subscribe(shiftTypesStore, CrudReponse.Delete).then((e: any) => {
            this.deleting = false;
            this.deleteDialog = false;
            this.close();
        }).catch((e: any) => {
            this.deleting = false;
        });
    }

}
